export default __webpack_public_path__ + "shapes-big.png?98e3b4465725e2968e97f2d70c07df4c";